/**
 * 注册js 助手到Vue示例和对象中
 */

import jquery from "jquery";
import Vue from "vue";
import VueRouter from "vue-router";
import freeAjaxHelper from './freeAjaxHelper';
import { appFetch } from './axiosHelper';
import wx from 'weixin-js-sdk'
let appConfig = require("../config/appConfig");
Vue.use(VueRouter)
window.$ = window.jQuery = jquery;

//loading状态
Vue.prototype.$selfloadingTime = 0;
Vue.prototype.$selfloadingBar = 0;

Vue.freeAjaxHelper = Vue.prototype.$freeAjaxHelper = freeAjaxHelper;
Vue.appFetch = Vue.prototype.$appFetch = appFetch;
Vue.wx = Vue.prototype.$wx = wx;
window.appConfig = Vue.appConfig = Vue.prototype.$appConfig = appConfig;













